module.exports = __webpack_public_path__ + "static/media/main.279bef07.less";


//////////////////
// WEBPACK FOOTER
// ./src/Content/Less/main.less
// module id = 957
// module chunks = 0